<template>
    <TopNav></TopNav>
    <h1>Калькулятор кубів</h1>
    <fieldset>
        <legend>Калькулятор кубів</legend>
        <label for="k">Ребер: </label><input type="number" v-model.number="inputValue" id="k">
        &nbsp;
        <select name="length" v-model.number="length">
            <option value="mm">mm</option>
            <option value="cm">cm</option>
            <option value="m">m</option>
            <option value="km">km</option>
        </select>
        <br><br>
        Об'єм: <span class="blue">{{ volumeFormatted }} {{ length }}<sup>3</sup></span>
        <br>
        Площа: <span class="blue">{{ areaFormatted }} {{ length }}<sup>2</sup></span>
    </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
    name: "CubeCalculator",
    data() {
        return {
            formatter: new Intl.NumberFormat('uk', {
                maximumFractionDigits: 5
            }),
            volumeFormatted: 0,
            areaFormatted: 0,
            length: "cm",
            inputValue: 0
        }
    },
    components: {
        TopNav
    },
    watch: {
        inputValue: function (newValue) {
            let volume = Math.pow(newValue, 3);
            this.volumeFormatted = this.formatter.format(volume);

            let area = 6 * Math.pow(newValue, 2);
            this.areaFormatted = this.formatter.format(area);
        }
    }
};
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}

body {
    margin: 1em auto;
    margin-top: 0;
    max-width: 40em;
    font-family: Arial, Helvetica, sans-serif;
}

label {
    display: inline-block;
    width: 70px;
}

footer section a {
    margin: 20px;
}

.blue {
    color: blue;
}
</style>
